import { Component, OnInit } from '@angular/core';
import { HabitosAlimentares } from '../../../models/HabitosAlimentares';
import { ActivatedRoute } from '@angular/router';
import { HabitosAlimentaresService } from '../../../services/habitos-alimentares/habitos-alimentares.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-habitos-alimentares-pessoa',
  imports: [
    CommonModule
  ],
  templateUrl: './habitos-alimentares-pessoa.html',
  styleUrl: './habitos-alimentares-pessoa.scss'
})
export class HabitosAlimentaresPessoa implements OnInit {
  pessoaId!: number;
  habitosAlimentares: HabitosAlimentares | null = null;

  constructor(
    private route: ActivatedRoute,
    private habitosAlimentaresService: HabitosAlimentaresService
  ) {}

  async ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      // this.pessoaId = 1;
      this.pessoaId = +id;
      this.habitosAlimentares = await this.habitosAlimentaresService.listarHabitosAlimentares(this.pessoaId);
    }
  }

  get refeicoesArray() {
    if (!this.habitosAlimentares) return [];

    const refeicoes = this.habitosAlimentares.refeicoes;

    return [
      { nome: 'Café da manhã', icone: '../../../../assets/images/refeicoes/cafe_manha.svg', dados: refeicoes.cafeDaManha },
      { nome: 'Lanche da manhã', icone: '../../../../assets/images/refeicoes/lanche_manha.svg', dados: refeicoes.lancheDaManha },
      { nome: 'Almoço', icone: '../../../../assets/images/refeicoes/almoco.svg', dados: refeicoes.almoco },
      { nome: 'Lanche da tarde', icone: '../../../../assets/images/refeicoes/lanche_tarde.svg', dados: refeicoes.lancheDaTarde },
      { nome: 'Janta', icone: '../../../../assets/images/refeicoes/janta.svg', dados: refeicoes.jantar },
      { nome: 'Ceia', icone: '../../../../assets/images/refeicoes/ceia.svg', dados: refeicoes.ceia }
    ].filter(item => item.dados?.selecionado);
  }
}
